// The exports in this file are used, and should only be used, to generate the program preview in the MySheerID program builder

import {
  type Locale,
  type Options,
  type ProgramTheme,
  type ProgramThemeMessages,
  type Segment,
} from "../types/types";

import "../../scss/sheerid-iframe.scss";
import { getMessages } from "../intl/intl";
import { setProgramTheme } from "../VerificationService/ProgramTheme/ProgramTheme";
import { VerificationFormEs5 } from "../../es5Bindings/VerificationFormEs5";
import { resetOptions, setOptions } from "../../options/options";
import { resetStore } from "../VerificationService/VerificationServiceStore";
import { Flags } from "../../components/FeatureFlags/flags";

export function loadInElement(containerElement: HTMLElement, programId: string) {
  const form = new VerificationFormEs5(containerElement, programId);
  return form;
}

export function setProgramThemeChoices(theme: ProgramTheme) {
  setProgramTheme(theme);
}

export function setProgramOptions(options: Options) {
  resetStore(); // Some options (e.g. locale) aren't correctly changed without resetting the store
  setOptions(options);
}

export function resetProgramOptions() {
  resetOptions();
}

export function getFeatureFlags(callback: (flags: Flags) => void) {
  setOptions({
    _launchDarklyFlagCb: callback,
  });
}

export function getProgramMessages(
  locale: Locale,
  programThemeMessages: ProgramThemeMessages,
  segment?: Segment,
) {
  return getMessages(locale, programThemeMessages, segment);
}

export default {
  loadInElement,
  getProgramMessages,
  getFeatureFlags,
  setProgramThemeChoices,
  setProgramOptions,
  resetProgramOptions,
};
